import React from 'react'

const EmployeeStatusSubcategory: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2242_11384)" />
    <g clipPath="url(#clip0_2242_11384)">
      <path
        d="M34.9684 44.0472C32.7618 44.0472 30.6182 44.0472 28.4115 44.0472C27.3397 44.0472 27.0245 43.6059 27.1506 42.5971C27.781 39.0034 30.9334 36.2293 34.5901 36.1032C38.436 35.9141 41.8406 38.436 42.7232 42.0927C43.1015 43.6059 42.7232 44.0472 41.2101 44.0472C39.1295 44.0472 37.049 44.0472 34.9684 44.0472Z"
        fill="white"
      />
      <path
        d="M35.0315 25.9526C37.4273 25.9526 39.3187 27.8441 39.2556 30.1768C39.2556 32.4465 37.2381 34.401 34.9684 34.401C32.6357 34.401 30.7443 32.4465 30.7443 30.1138C30.7443 27.781 32.6357 25.9526 35.0315 25.9526Z"
        fill="white"
      />
      <g opacity="0.35">
        <path
          d="M35.0315 53C25.0701 53 17 44.9299 17 35.0315C17 25.1331 25.0701 17 35.0315 17C44.993 17 53.063 25.0701 53.063 35.0315C53.063 44.993 44.9299 53 35.0315 53ZM35.0315 20.1524C26.8354 20.1524 20.1524 26.8354 20.1524 35.0315C20.1524 43.2277 26.8354 49.9107 35.0315 49.9107C43.2277 49.9107 49.9107 43.2277 49.9107 35.0315C49.9107 26.8354 43.2277 20.1524 35.0315 20.1524Z"
          fill="white"
        />
      </g>
      <path
        d="M35.0316 53C31.2487 53 27.655 51.8652 24.5657 49.6585C23.8722 49.1541 23.6831 48.1454 24.1874 47.4518C24.6918 46.7583 25.7006 46.5692 26.3941 47.0736C28.916 48.9019 31.9422 49.8476 35.0316 49.8476C43.2277 49.8476 49.9107 43.1646 49.9107 34.9685C49.9107 26.7723 43.2277 20.1524 35.0316 20.1524C34.1489 20.1524 33.4554 19.4588 33.4554 18.5762C33.4554 17.6935 34.1489 17 35.0316 17C44.993 17 53.0631 25.0701 53.0631 35.0315C53.0631 44.993 44.93 53 35.0316 53Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2242_11384"
        x1="-1.56654e-06"
        y1="4.96155"
        x2="70"
        y2="66.9615"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E5A100" />
        <stop offset="1" stopColor="#F14B12" />
      </linearGradient>
      <clipPath id="clip0_2242_11384">
        <rect width="36" height="36" fill="white" transform="translate(17 17)" />
      </clipPath>
    </defs>
  </svg>
)

export default EmployeeStatusSubcategory
